module.exports = __webpack_public_path__ + "img/check.3b7287b5.svg";